import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegionLookupComponent } from './region-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [RegionLookupComponent],
  exports: [RegionLookupComponent]
})
export class RegionLookupModule { }
